<div class="app-mian-header">
  <div class="header-inner">
    <a class="logo-mobile" [routerLink]="['/admin/central-apps']">
      <img src="/assets/images/logos/sdaia_logo_white.png" alt="" />
    </a>
    <div class="header-actions">
      <nav class="navbar navbar-expand-lg navbar-light">
        <button class="navbar-toggler" (click)="collapse = !collapse" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="navbar-collapse collapse" [ngClass]="{'show': collapse}" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item" *ngIf="currentUser?.showAdminPanel">
              <a [routerLink]="['/admin/administration-panel']" routerLinkActive="active" class="active nav-link">{{
                "menu.administrationPanel" |
                translate }}</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/central-apps']" routerLinkActive="active" class="active nav-link">{{
                "menu.centralAppsHub" | translate
                }}</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/admin/credentials-management']" routerLinkActive="active" class="active nav-link">{{
                "menu.credentialsManagement" |
                translate }}</a>
            </li>
          </ul>
        </div>
      </nav>

    </div>
    <div class="header-part-right">
      <div class="elementor-widget-container">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()">
            <span class="notification-count">{{
              notificationsResult.unSeenNotificationsCount
              }}</span>
            <img src="./assets/images/icons/notifications-icon.svg" [ngClass]="{
                  swing: notificationsResult.unSeenNotificationsCount
                }" />
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="notification-header">
              <h3>{{ "general.Notification" | translate }}</h3>
            </div>

            <div class="notifications-wrapper">
              <div *ngIf="notifLoading" class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <ng-container *ngIf="!notifLoading">
                <div class="no-data text-center d-flex align-items-center justify-content-center h-100 px-2 py-5"
                  *ngIf="!notificationsList.length">
                  {{ "general.You have no notifications" | translate }}!
                </div>
                <div *ngIf="notificationsList.length">
                  <div class="notification-list" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="pageCount" (scrolled)="getNextPage()">
                    <div *ngFor="let notif of notificationsList" [ngClass]="notif.isSeen ? '' : 'new'"
                      (click)="seeNotifications(notif)">
                      <ng-container [ngSwitch]="notif?.notificationType">
                        <a class="notification-record" *ngSwitchCase="notificationType.Request_Update"
                          [routerLink]="(['/admin/central-apps/shared-tools',toolCodeEnum.File_Share_Permission_Manager,'details',notif.objectId] | internalRoute)">
                          <ng-container [ngTemplateOutlet]="notifContent"
                            [ngTemplateOutletContext]="{notif}"></ng-container>
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-widget-container">
        <div class="assigned_releases dropdown-container" appDropDown>
          <span class="assigned_releases_btn" (click)="openReleasesPanel()">
            <img src="./assets/images/icons/assigned_releases_ic.svg" />
          </span>

          <div class="releases-panel dropdown-inner-menu">
            <div class="releases-header">
              <h3>{{ "general.myReleases" | translate }}</h3>
              <p>{{ "general.releasesCurrentlyAssignedToYourAccount" | translate }}</p>
            </div>

            <div class="releases-wrapper">
              <div *ngIf="releasesLoading" class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <ng-container *ngIf="!releasesLoading">
                <div class="no-data text-center d-flex align-items-center justify-content-center h-100 px-2 py-5"
                  *ngIf="!releasesList.length">
                  {{ "general.noReleases" | translate }}!
                </div>
                <div *ngIf="releasesList.length">
                  <div class="releases-list">
                    <div class="releases-list-header">
                      <span>{{ "appsConfiguration.application" | translate }}</span>
                      <span>{{ "general.numberOfReleases" | translate }}</span>
                    </div>
                    <ul>
                      <li *ngFor="let item of releasesList">
                        <a
                          [routerLink]="['/admin/central-apps/applications',item.applicationId,toolCodeEnum.Azure_Devops, 'releases']">
                          <div class="app-name" [matTooltip]="item.applicationName">
                            <span class="app-icon">
                              <img [src]="item.applicationImage || './assets/images/icons/projects_default_logo.png'">
                            </span> {{item.applicationName}}
                          </div>
                          <span>{{item.count}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler d-flex align-items-center">
            <div class="profile-image">
              <img *ngIf="currentUser.userImage" [src]="currentUser.userImage" (error)="currentUser.userImage = ''" />
              <span *ngIf="!currentUser.userImage">{{currentUser.username | shortName}}</span>
            </div>
            <div class="user-name">
              <span class="mr-2"> {{ currentUser.username }}</span>
            </div>
          </div>

          <div class="custom-dropdown-menu dropdown-inner-menu">
            <ul>
              <!-- <li>
                <a [routerLink]="['/']">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path id="ic_profile"
                      d="M102.6-849.1a8.041,8.041,0,0,1,2.047-1.1,6.827,6.827,0,0,1,2.357-.4,6.827,6.827,0,0,1,2.357.4,8.041,8.041,0,0,1,2.047,1.1,5.809,5.809,0,0,0,1.089-1.749,5.682,5.682,0,0,0,.4-2.151,5.682,5.682,0,0,0-1.722-4.172A5.682,5.682,0,0,0,107-858.895a5.682,5.682,0,0,0-4.172,1.722A5.682,5.682,0,0,0,101.105-853a5.682,5.682,0,0,0,.4,2.151A5.809,5.809,0,0,0,102.6-849.1Zm4.4-3.347a2.314,2.314,0,0,1-1.7-.693,2.313,2.313,0,0,1-.693-1.7,2.314,2.314,0,0,1,.693-1.7,2.313,2.313,0,0,1,1.7-.693,2.314,2.314,0,0,1,1.7.693,2.313,2.313,0,0,1,.693,1.7,2.314,2.314,0,0,1-.693,1.7A2.313,2.313,0,0,1,107-852.447ZM107-846a6.861,6.861,0,0,1-2.736-.548,7.028,7.028,0,0,1-2.223-1.494,7.028,7.028,0,0,1-1.494-2.222A6.861,6.861,0,0,1,100-853a6.861,6.861,0,0,1,.548-2.736,7.028,7.028,0,0,1,1.494-2.222,7.028,7.028,0,0,1,2.223-1.494A6.861,6.861,0,0,1,107-860a6.861,6.861,0,0,1,2.736.548,7.028,7.028,0,0,1,2.223,1.494,7.028,7.028,0,0,1,1.494,2.222A6.861,6.861,0,0,1,114-853a6.861,6.861,0,0,1-.548,2.736,7.028,7.028,0,0,1-1.494,2.222,7.028,7.028,0,0,1-2.223,1.494A6.861,6.861,0,0,1,107-846Zm0-1.105a5.833,5.833,0,0,0,1.924-.321,5.461,5.461,0,0,0,1.644-.9,5.6,5.6,0,0,0-1.623-.866A5.955,5.955,0,0,0,107-849.5a6.052,6.052,0,0,0-1.948.307,5.343,5.343,0,0,0-1.62.87,5.461,5.461,0,0,0,1.644.9A5.833,5.833,0,0,0,107-847.105Zm0-6.447a1.248,1.248,0,0,0,.92-.37,1.248,1.248,0,0,0,.37-.92,1.248,1.248,0,0,0-.37-.92,1.248,1.248,0,0,0-.92-.37,1.248,1.248,0,0,0-.92.37,1.248,1.248,0,0,0-.37.92,1.248,1.248,0,0,0,.37.92A1.248,1.248,0,0,0,107-853.553ZM107-854.842ZM107-848.3Z"
                      transform="translate(-100 860)" fill="#5d6d7e" />
                  </svg>
                  {{ "general.View Profile" | translate }}
                </a>
              </li> -->
              <li>
                <a (click)="logout()">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                      <path id="ic_log_out"
                        d="M16173.752,16742a3.755,3.755,0,0,1-3.751-3.75v-10.5a3.755,3.755,0,0,1,3.751-3.75h1.5a.75.75,0,0,1,0,1.5h-1.5a2.251,2.251,0,0,0-2.251,2.25v10.5a2.251,2.251,0,0,0,2.251,2.25h1.5a.75.75,0,0,1,0,1.5Zm9.382-3.969a.75.75,0,0,1,.019-1.061l2.91-2.91a1.5,1.5,0,0,0,.25-.346.518.518,0,0,1-.059.012l-11.761.023a.75.75,0,0,1,0-1.5l11.766-.023c.011,0,.021.006.031.006a1.556,1.556,0,0,0-.225-.293l-2.91-2.908a.75.75,0,0,1,1.061-1.061l2.91,2.908h0a3,3,0,0,1,0,4.242l-2.91,2.91-.019.018a.75.75,0,0,1-1.061-.018Z"
                        transform="translate(-16169.501 -16723.502)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                        stroke-miterlimit="10" stroke-width="1" />
                    </svg>
                  </span>
                  {{ "general.Logout" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notifContent let-notif="notif">
  <span>{{notif.date | date:'d MMM yyyy - h:mm a' | capitalizeMonth}}</span>
  <!-- <h3>{{notif.title}}</h3> -->
  <p>{{notif.text}}</p>
</ng-template>
